import React, { useCallback, useRef } from 'react'
// @ts-ignore - google-map-react has type issues with React 18
import GoogleMapReact from 'google-map-react'
import { type NurseryItemData } from '../nureseries/type'
import { useSearchStore } from '../../../store/jpeTopPageStore'
import { MAP_CENTER, ZOOM_LIMITS, getMapOptions, japaneseAirports } from './mapConstants'
import { MarkerWrapper } from './MarkerWrapper'
import { NurseryMarker } from './NurseryMarker'
import { AirportMarker } from './AirportMarker'

// Cast GoogleMapReact to any to avoid React 18 type issues
const Map = GoogleMapReact as any

export const MapContainer: React.FC = () => {
  const {
    nurseries,
    selectedNurseryId,
    setSelectedNurseryId,
    setSelectedNursery,
    setSelectedPinPosition,
    setSelectedMarkerRef,
    clearSelection,
    isDesktop,
  } = useSearchStore()

  const markerRefsMap = useRef<{ [key: number]: HTMLDivElement }>({})

  const handleMarkerClick = useCallback(
    (nursery: NurseryItemData, position: { x: number; y: number }) => {
      setSelectedNurseryId(nursery.id)
      setSelectedNursery(nursery as any)
      setSelectedPinPosition(position)
      const markerEl = markerRefsMap.current[nursery.id]
      if (markerEl) {
        setSelectedMarkerRef(markerEl)
      }
    },
    [setSelectedNurseryId, setSelectedNursery, setSelectedPinPosition, setSelectedMarkerRef],
  )

  const handleMapClick = useCallback(() => {
    clearSelection()
  }, [clearSelection])

  const handleZoomChange = useCallback((_zoom: number) => {}, [])

  // Get Google Maps API key from config or fallback to window variable
  const apiKey = (document.getElementById('maps_javascript_api_key') as HTMLInputElement)?.value

  return (
    <div className="h-full relative">
      <Map
        bootstrapURLKeys={{ key: apiKey }}
        defaultCenter={MAP_CENTER}
        defaultZoom={isDesktop ? ZOOM_LIMITS.desktop.default : ZOOM_LIMITS.mobile.default}
        onClick={handleMapClick}
        onZoomAnimationEnd={handleZoomChange}
        yesIWantToUseGoogleMapApiInternals
        options={getMapOptions(isDesktop)}
      >
        {/* Airport markers (rendered first so nurseries appear on top) */}
        {japaneseAirports.map((airport) => (
          <MarkerWrapper
            key={airport.code}
            lat={airport.lat}
            lng={airport.lng}
            $hover={false}
            $getDimensions={() => {}}
            $dimensionKey={''}
            $geoService={null}
            $onMouseAllow={false}
            $prerender={false}
          >
            <AirportMarker key={airport.code} airport={airport} />
          </MarkerWrapper>
        ))}
        {/* Nursery markers */}
        {nurseries.map((nursery) => {
          const isActive = selectedNurseryId === nursery.id
          return (
            <MarkerWrapper
              key={nursery.id}
              lat={nursery.latitude}
              lng={nursery.longitude}
              $hover={false}
              $getDimensions={() => {}}
              $dimensionKey={''}
              $geoService={null}
              $onMouseAllow={false}
              $prerender={false}
              setRef={(el: HTMLDivElement | null) => {
                if (el) {
                  markerRefsMap.current[nursery.id] = el
                } else {
                  delete markerRefsMap.current[nursery.id]
                }
              }}
            >
              <NurseryMarker nursery={nursery} isActive={isActive} onClick={handleMarkerClick} />
            </MarkerWrapper>
          )
        })}
      </Map>
    </div>
  )
}
